/* import __COLOCATED_TEMPLATE__ from './qa-status-selector.hbs'; */
/* RESPONSIBLE TEAM: team-inbox */

import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { inject as service } from '@ember/service';
import type IntlService from 'embercom/services/intl';

interface QaStatusOption {
  id: string | number;
  label: string;
  archived: boolean;
}

interface Args {
  selectedStatus?: string | null;
  onSelect: (status: string | null) => void;
  options: QaStatusOption[];
  dropdownClass?: string;
  showRemoveButton?: boolean;
  onRemove?: (event?: Event) => void;
}

interface Signature {
  Args: Args;
  Element: HTMLElement;
}

export default class QaStatusSelector extends Component<Signature> {
  @service declare intl: IntlService;
  @tracked isHovered = false;

  get label() {
    this.intl.primaryLocale; // Make this getter aware of locale changes

    if (!this.args.selectedStatus) {
      return this.intl.t('inbox.search.filters.qa-status.none');
    }

    // Find the label for the selected status
    let option = this.args.options.find((opt) => opt.id === this.args.selectedStatus);
    return option?.label || this.args.selectedStatus;
  }

  get items() {
    this.intl.primaryLocale; // Make this getter aware of locale changes

    let statusItems = this.args.options
      .filter((option) => !option.archived)
      .map((option) => ({
        text: option.label,
        value: option.id as string | number | null,
        isSelected: option.id === this.args.selectedStatus,
        component: 'inbox2/left-nav/conversation-list/filters-item',
      }));

    let groups = [{ items: statusItems }];

    // Add clear option if a value is selected
    if (this.args.selectedStatus) {
      groups.push({
        items: [
          {
            text: this.intl.t('inbox.search.filters.qa-status.clear'),
            value: null as string | number | null,
            isSelected: false,
            component: 'inbox2/left-nav/conversation-list/filters-item',
          },
        ],
      });
    }

    return groups;
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Inbox2::Search::QaStatusSelector': typeof QaStatusSelector;
    'inbox2/search/qa-status-selector': typeof QaStatusSelector;
  }
}
